import Image from "next/image";
import React from "react";
import Headline from "../../../../../partials/elements/Headline";
import InitiativeCardIcons from "./components/InitiativeCardIcons";
import InitiativeCounter from "./components/InitiativeCounter";

export default function InitiativeCard({ governmentInitiative }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-5 max-w-4xl mx-auto">
      {governmentInitiative?.map((item, i) => (
        <div
          key={i}
          item={item}
          className="w-24 md:w-32 mx-auto relative group"
        >
          <div className="border border-dashed border-primary h-24 md:h-32 flex justify-center items-center rounded-full relative group-hover:bg-blue-600 duration-300">
            <InitiativeCardIcons icon={item.icon}   />
            <InitiativeCounter i={i} />
          </div>
          <Headline
            text={item.title}
            extraClass={"text-sm md:text-lg font-bold text-center px-2 py-4"}
          />
        </div>
      ))}
    </div>
  );
}
